<div class="checkbox">
    <label *ngFor="let company of companyList">
        <input checked="company.SELECTED" type="checkbox"(click)="changes(company,$event)"> Gangaram Hospital Parking
    </label>
</div>